import React, { useState, useMemo, useEffect } from "react";
import { productsData } from "../../assets/data/data";
import "./styles.css";
import { Link } from "react-router-dom";
import { db } from "../../assets/firebase/firebaseconfig"; // Đường dẫn file config của bạn
import { ref, onValue, get , update} from "firebase/database";
import Loading from "../Loading";
import { Helmet } from "react-helmet-async";
import { createSlug } from "../../assets/js/slug";
const ProductPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [activeCategory, setActiveCategory] = useState("Tất cả sản phẩm");
  const [activeBrand, setActiveBrand] = useState("Tất cả thương hiệu");
  const [visibleCount, setVisibleCount] = useState(10);


// Bên trong Component
useEffect(() => {
  const syncSlugs = async () => {
    const productsRef = ref(db, "products");
    const snapshot = await get(productsRef);
    
    if (snapshot.exists()) {
      const updates = {};
      const data = snapshot.val();
      let hasUpdate = false;

      Object.keys(data).forEach((key) => {
        // Chỉ cập nhật nếu sản phẩm CHƯA có slug
        if (!data[key].slug) {
          updates[`/products/${key}/slug`] = createSlug(data[key].name);
          hasUpdate = true;
        }
      });

      if (hasUpdate) {
        await update(ref(db), updates);
        console.log("✅ Đã cập nhật slug cho tất cả sản phẩm!");
      }
    }
  };

  syncSlugs();
}, []);
  const categories = useMemo(() => {
    if (!products || products.length === 0) return ["Tất cả sản phẩm"];

    // Dùng filter(Boolean) để loại bỏ các giá trị null/undefined nếu sản phẩm đó thiếu trường category
    const allCats = products.map((p) => p.category).filter(Boolean);
    return ["Tất cả sản phẩm", ...new Set(allCats)];
  }, [products]);

  const brands = useMemo(() => {
    if (!products || products.length === 0) return ["Tất cả thương hiệu"];

    const allBrands = products.map((p) => p.brand).filter(Boolean);
    return ["Tất cả thương hiệu", ...new Set(allBrands)];
  }, [products]);

  // 1. Logic Lọc thực tế
  const filteredProducts = useMemo(() => {
    if (!products) return [];

    return products.filter((p) => {
      // Ép kiểu về String và Trim khoảng trắng để so sánh chính xác tuyệt đối
      const pCat = String(p.category || "").trim();
      const pBrand = String(p.brand || "").trim();

      const matchCat =
        activeCategory === "Tất cả sản phẩm" || pCat === activeCategory;

      const matchBrand =
        activeBrand === "Tất cả thương hiệu" || pBrand === activeBrand;

      return matchCat && matchBrand;
    });
  }, [products, activeCategory, activeBrand]);
  // 3. Hàm reset khi lọc (để nút Xem thêm hiện lại đúng số lượng)
  const changeCategory = (cat) => {
    setActiveCategory(cat);
    setVisibleCount(10);
  };
  const changeBrand = (brand) => {
    setActiveBrand(brand);
    setVisibleCount(10);
  };

  const displayedProducts = filteredProducts.slice(0, visibleCount);
  const remainingCount = filteredProducts.length - visibleCount;

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 10);
  };
  useEffect(() => {
    // Mỗi khi activeCategory hoặc activeBrand thay đổi, thực hiện cuộn lên đầu
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Cuộn mượt mà lên đầu trang
    });
  }, [activeCategory, activeBrand]);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show"); // Thêm class show khi thấy phần tử
          }
        });
      },
      { threshold: 0.1 }
    ); // Thấy 10% phần tử là chạy hiệu ứng

    // Quét toàn bộ các card có class reveal-on-scroll
    const elements = document.querySelectorAll(".reveal-on-scroll");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [displayedProducts]); // Chạy lại mỗi khi có thêm sản phẩm
  useEffect(() => {
    const productRef = ref(db, "products");

    // Lắng nghe dữ liệu thời gian thực
    const unsubscribe = onValue(productRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        // Chuyển object từ Firebase thành mảng để dễ dùng .map()
        const productList = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setProducts(productList);
        setLoading(false)
      } else {
        setProducts([]);
      }
      setLoading(false);
    });

    return () => unsubscribe(); // Hủy lắng nghe khi component bị gỡ bỏ
  }, []);

  if (loading) return <Loading />;
  console.log("PPP", products);
  return (
    <div className="shopee-page-bg">
      <Helmet>
    <title key="product">Danh Mục Thiết Bị Cơ Điện Chính Hãng | Habako M&E</title>
    <meta name="description" content="Tổng hợp thiết bị điện công nghiệp, vật tư cơ điện. Xem ngay bảng giá và thông số kỹ thuật mới nhất tại Habako." />
  </Helmet>
      <div className="container shopee-layout">
        <aside className="shopee-sidebar">
          {}
          <div className="sidebar-section">
            <h3 className="sidebar-header">
              <i className="fas fa-list"></i> DANH MỤC
            </h3>
            <ul className="sidebar-list">
              {categories.map((cat) => (
                <li
                  key={cat}
                  className={`sidebar-item ${
                    activeCategory === cat ? "active" : ""
                  }`}
                  onClick={() => changeCategory(cat)}
                >
                  {cat}
                </li>
              ))}
            </ul>
          </div>
          <div className="sidebar-divider"></div>
          {}
          <div className="sidebar-section">
            <h3 className="sidebar-header">
              <i className="fas fa-filter"></i> THƯƠNG HIỆU
            </h3>
            <ul className="sidebar-list">
              {brands.map((b) => (
                <li
                  key={b}
                  className={`sidebar-item ${
                    activeBrand === b ? "active" : ""
                  }`}
                  onClick={() => changeBrand(b)}
                >
                  {b}
                </li>
              ))}
            </ul>
          </div>
        </aside>

        <main className="shopee-main">
          <div className="products-grid-shopee">
            {displayedProducts.length > 0 ? (
              displayedProducts.map((product) => (
                <Link
                  to={`/san-pham/${product.slug || createSlug(product.name)}`}
                  key={product.id}
                  className="product-card-shopee reveal-on-scroll"
                >
                  <div className="product-image">
                    <img src={product.mediaUrl} alt={product.name} />
                    {}
                    <div className="hover-overlay">
                      <button className="btn-view-detail">Xem chi tiết</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h3 className="product-name">{product.name}</h3>

                    <p style={{ fontSize: "10px" }}>
                      Mục:{" "}
                      <span style={{ color: "blue" }}>
                        {product.category ? product.category : "khác"}
                      </span>
                    </p>
                    <p>
                      Thương hiệu:{" "}
                      <span style={{ color: "blue", fontSize: "12px" }}>
                        {product.brand ? product.brand : "khác"}
                      </span>
                    </p>
                    <div className="product-price-row">
                      <span className="price-current">Liên hệ</span>
                    </div>
                  </div>
                </Link>
              ))
            ) : (
              <p></p>
            )}
          </div>

          {visibleCount < filteredProducts.length && (
            <div className="show-more-container">
              <button className="btn-show-more-custom" onClick={handleShowMore}>
                Xem thêm {remainingCount} sản phẩm
              </button>
            </div>
          )}
          {filteredProducts.length === 0 && <p>Hiện không có sản phẩm nào</p>}
        </main>
      </div>
    </div>
  );
};

export default ProductPage;
